<template>
    <div class="bloco-dados-certificacao">
        <h2 class="titulo-bloco-dados-gerais-certificacao">
            {{ $tc('certification.messages.general_territory_data') }}
        </h2>
        <el-card>
            <div class="bloco-dados-gerais-certificacao-informacao">
                <div class="bloco-dados-gerais-certificacao-informacao__item">
                    <h4>{{ $tc('certification.messages.linked_cars')}}</h4>
                    <template v-for="car in dadosCertificacao.cars">
                        <span :key="car.codigo">{{car.codigo}}</span>
                    </template>
                </div>
                <div class="bloco-dados-gerais-certificacao-informacao__item">
                    <h4>{{ $tc('certification.words.locality')}}</h4>
                    <span>
                        {{dadosCertificacao.dadosTerritorio[0].municipioTerritorioNome}} / {{dadosCertificacao.dadosTerritorio[0].estadoTerritorioSigla}}
                    </span>
                </div>
                <div class="bloco-dados-gerais-certificacao-informacao__item">
                    <h4>{{ $tc('certification.words.person', 2)}}</h4>
                    <template v-for="representante in dadosCertificacao.representantes">
                        <span :key="representante.nomeRepresentante">{{representante.nomeRepresentante}}</span>
                    </template>
                </div>
                <div class="bloco-dados-gerais-certificacao-informacao__item">
                    <h4>{{ $tc('certification.words.analysis_date')}}</h4>
                    <span>
                        {{dadosCertificacao.dataAnalise }}
                    </span>
                </div>
                <div class="bloco-dados-gerais-certificacao-informacao__item">
                    <h4>{{ $tc('certification.messages.last_harvest_year')}}</h4>
                    <span>
                        {{dadosCertificacao.safra }}
                    </span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'BlocoDadosGeraisCertificacao',
    components: {},

    props: {
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },

    data() {
        return {};
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
.bloco-dados-certificacao {
    .titulo-bloco-dados-gerais-certificacao {
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }

    .bloco-dados-gerais-certificacao-informacao {
        display:grid;
        min-width: 155px;
        grid-template-columns: 2fr 1fr 2fr 1fr 1fr;

        .bloco-dados-gerais-certificacao-informacao__item {
            margin-right: 20px;
            margin-bottom: 20px;
            width: 100%;
            display: flex;
            flex-direction: column;

            h4 {
                font-weight: bold;
                margin-bottom: 5px;
                color: var(--primary);
            }
            span {
                font-size: 12px;
            }
        }

        .bloco-dados-gerais-certificacao-informacao__paragrafo {
            margin-top: 9px;

            .lista-scroll {
                max-height: 110px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                min-height: 70px;
                padding: 0px;

                p {
                    margin-bottom: 2px;
                }
            }
        }
    }
}
</style>
